export const VOTER_SEARCH_API_CONSTANTS = {
  SEARCH_RESULT_TABLE_CONFIG:
    "/assets/page-configs/voter-search-result-list.json",
  SEARCH_RESULT_TABLE_CONFIG_SEARCH_VIEW:
    "/assets/page-configs/voter-search-result-list-search-view.json",
    SEARCH_HISTORY_TABLE_CONFIG_SEARCH_VIEW:
    "/assets/page-configs/search-history.json",
  SEARCH_BY_VOTER_ID: "/voter/search",
  SEARCH_BY_GENERAL: "/voter/search",
  SEARCH_BY_PHONE: "/voter/search",
  VOTOR_DATA: "/visitor",
  CAST: "/visitor/cast/subcast",
  SEARCH_BY_ALPHABET: "",
  BOOTH_NAME_DATA: "/voter/search/getBoothDetails",
  WILD_SEARCH: "/voter/search/wildSearch",
  SURNAME_DATA: "/voter/search/wildSearch",
  VOTER_SEARCH: "/voter/search",
  VOTER_SEARCH_EXPORT: "/voter/search/export",
  INIT_SURNAME_DATA: "/voter/search/getlastNameDetails",
  VOTER_SEARCH_API_CONFIG:"/voter-search-configs",
  GET_FAMILY_MEMBER:"/voter/search/getFamilyMembers",
  REMOVE_FAMILY_MEMBER:"/voter/search/removeFamilyMember",
  ADD_FAMILY_MEMBER:"/voter/search/addFamilyMember",
  FILE_UPLOAD_VOTER_SEARCH_CONFIG:"/file-uploader/uploadS3?entityName=voter-search-config",
  VOTER_PUBLIC_SEARCH_HISTORY_API:"/notifications/getSMSReport/",
  DOWNLOAD_EXCEL_SEARCH_HISTORY:"/notifications/exportSMSReport"
};

export const VOTER_SEARCH_CONFIG_CONSTANTS = {
  SURNAME_TABLE_CONFIG: "/assets/page-configs/surname-list.json",
};
